import {
  //general
  getCvAllSourceType,
  getCvRoot,
  getCvSpecies,
  getCvSourceType,
  getCvStrain,
  getCvGenotype,
  getCvSamUnit,
  getCvGender,
  getCvAllStrain,
  // type
  getCvSystemName,
  getCvOrganName,
  getCvOrganAndSystem,
  getCvTissueName,
  getCvTissueStatus,
  getCvCellName,
  getCvCellType,
  getCvMicroorganismType,
  getCvMicroorganismName,
  getCvOrganelle,
  getCvFluid,
  // storage
  getCvLocationType,
  getCvLocationTemperature,
  // treatment
  getCvTreatmentMethod,
  getCvTreatmentType,
  getCvUnitType,
  getCvUnit,
  getCvUnitAll,
  // submit
  getSubmist,
  getSampleListData,
  getSampleListCount,
  // search & filter
  getDistinctDescription,
  getDistinctOperator,
  getDistinctSourceType,
  getDistinctTreatmentA,
  getDistinctTreatmentB,
  // edit sample
  getSampleView,
  // show sample
  getSampleListAndStickAnEntry,
  // draft sample
  getSampleListInProvidedIds,
  getSampleListNotInProvidedIds,
  getSampleListNotInProvidedIdCount,
  // modify sample
  modifySample,
  deleteSample,
  getSampleTemplate
} from 'api/samples'

const samples = {
  state: {
    rootId: 1,
    list: {},
    highLightTableList: {},
    // draft sample
    draftShowSampleTableList: [],
    draftSelectOtherSamTableList: [],
    // general
    allSourceType: [],
    rootClassification: [],
    species: [],
    sampleType: [],
    strain: [],
    genoType: [],
    ageUnit: [],
    gender: [],
    allStrain: [],
    // type
    tissueFormList: {
      systemName: '',
      systemNameId: '',
      organName: '',
      organNameId: '',
      tissueName: '',
      tissueNameId: '',
      tissueStatus: '',
      tissueStatusId: ''
    },
    cellFormList: {
      systemName: '',
      systemNameId: '',
      organName: '',
      organNameId: '',
      tissueName: '',
      tissueNameId: '',
      cellType: '',
      cellTypeId: '',
      cellName: '',
      cellNameId: ''
    },
    organelleFormList: {
      systemName: '',
      systemNameId: '',
      organName: '',
      organNameId: '',
      tissueName: '',
      tissueNameId: '',
      cellType: '',
      cellTypeId: '',
      cellName: '',
      cellNameId: '',
      organelleName: '',
      organelleNameId: ''
    },
    systemName: [],
    organName: [],
    systemAOrgan: [],
    tissueName: [],
    tissueStatus: [],
    cellName: [],
    cellType: [],
    microorganismType: [],
    microorganismName: [],
    organelle: [],
    fluid: [],
    formValue: {
      fluid: [],
      system: [],
      organ: [],
      tissue: [],
      cellType: [],
      cellName: [],
      microType: [],
      microName: [],
      orgType: [],
      tissueStatus: []
    },
    // storage
    storageType: [],
    storageTemperature: [],
    // treatment
    treatmentMethod: [],
    treatmentType: [],
    treatmentUnit: [],
    treatmentUnitType: [],
    teatmentAllUnit: [],
    // table
    sampleTableList: [],
    // search & filter
    searchDescription: '',
    searchTreatmentA: '',
    searchTreatmentB: '',
    filterOperator: [],
    filterSourceType: [],
    // edit sample
    checkSample: []
  },
  mutations: {
    SET_ROOTID: (state, num) => {
      state.rootId = num
    },
    SET_LIST: (state, list) => {
      state.list[list.key] = list.list
    },
    SET_EMPTYLIST: (state, list) => {
      state.list = list
    },
    // general
    SET_ALLSOURCETYPELIST: (state, list) => {
      state.allSourceType = list
    },
    SET_AGEUNIT: (state, list) => {
      state.ageUnit = list
    },
    SET_ROOTCLASSIFICATION: (state, list) => {
      state.rootClassification = list
    },
    SET_SPECIES: (state, list) => {
      state.species = list
    },
    SET_SOURCETYPE: (state, list) => {
      /*state.sampleType = list.map((item) => {
        for (var key in item) {
          return {
            value: key,
            label: item[key]
          }
        }
      })*/
    },
    SET_ALLSTRAIN: (state, list) => {
      state.allStrain = list
    },
    SET_STRAIN: (state, list) => {
      state.strain = list
    },
    SET_GENOTYPE: (state, list) => {
      state.genoType = list
    },
    SET_GENDER: (state, list) => {
      state.gender = list
    },
    // type
    SET_TISSUEFORMLIST: (state, list) => {
      state.tissueFormList = list
    },
    SET_CELLFORMLIST: (state, list) => {
      state.cellFormList = list
    },
    SET_ORGANFORMLIST: (state, list) => {
      state.organelleFormList = list
    },
    SET_FORMVALUE: (state, list) => {
      state.formValue = list
    },
    SET_SYSTEMNAME: (state, list) => {
      state.systemName = list
    },
    SET_ORGANNAME: (state, list) => {
      state.organName = list
    },
    SET_SYSORGAN: (state, list) => {
      state.systemAOrgan = list
    },
    SET_TISSUENAME: (state, list) => {
      state.tissueName = list
    },
    SET_TISSUESTATUS: (state, list) => {
      state.tissueStatus = list
    },
    SET_CELLNAME: (state, list) => {
      state.cellName = list
    },
    SET_CELLTYPE: (state, list) => {
      state.cellType = list
    },
    SET_MICROORGANISMTYPE: (state, list) => {
      state.microorganismType = list
    },
    SET_MICROORGANISMNAME: (state, list) => {
      state.microorganismName = list
    },
    SET_ORGANELLE: (state, list) => {
      state.organelle = list
    },
    SET_FLUID: (state, list) => {
      state.fuild = list
    },
    // storage
    SET_STORAGETYPE: (state, list) => {
      state.storageType = list
    },
    SET_STORAGETEMPERATURE: (state, list) => {
      state.storageTemperature = list
    },
    // treatment
    SET_TREATMENTMETHOD: (state, list) => {
      state.treatmentMethod = list
    },
    SET_TREATMENTTYPE: (state, list) => {
      state.treatmentType = list
    },
    SET_TREATMENTUINITTYPE: (state, list) => {
      state.treatmentUnitType = list
    },
    SET_TREATMENTUNIT: (state, list) => {
      state.treatmentUnit = list
    },
    SET_TREATMENTALLUNIT: (state, list) => {
      state.teatmentAllUnit = list
    },
    // table
    SET_SAMPLETABLELIST: (state, list) => {
      state.sampleTableList = list
      // console.log(state.sampleTableList)
    },
    SET_HIGHLIGHTLIST: (state, list) => {
      state.highLightTableList = list
    },
    // search & filter
    SET_SEARCHDESCRIP: (state, word) => {
      state.searchDescription = word
    },
    SET_FILTEROPERATOR: (state, list) => {
      state.filterOperator = list
    },
    SET_FILTERSOURCETYPE: (state, list) => {
      state.filterSourceType = list
    },
    SET_SEARCHTREATMENTA: (state, word) => {
      state.searchTreatmentA = word
    },
    SET_SEARCHTREATMENTB: (state, word) => {
      state.searchTreatmentB = word
    },
    SET_CHECKSAMPLE: (state, data) => {
      state.checkSample = data
    },
    SET_DRAFTSHOWSAMPLETABLEDATA: (state, list) => {
      state.draftShowSampleTableList = list
    },
    SET_DRAFTSELECTOTHERSAMTABLEDATA: (state, list) => {
      state.draftSelectOtherSamTableList = list
    }
  },
  actions: {
    getDBFormList ({commit}, list) {
      commit('SET_LIST', list)
    },
    getEmptyDBFormList: ({commit}, list) => {
      commit('SET_EMPTYLIST', list)
    },
    getSamplesFormList ({commit}, list) {
      // console.log(list)
      commit('SET_LIST', list)
    },
    getEmptySamplesList: ({commit}, list) => {
      commit('SET_EMPTYLIST', list)
    },
    getRootId ({commit}, num) {
      commit('SET_ROOTID', num)
    },
    /*general*/
    getCvAllStrain ({commit, state}) {
      return new Promise((resolve, reject) => {
        getCvAllStrain().then((res) => {
          console.log(res)
          commit('SET_ALLSTRAIN', res.result.allStrain)
          resolve(res.result.allStrain)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCvAllSourceType ({commit, state}) {
      return new Promise((resolve, reject) => {
        getCvAllSourceType().then((res) => {
          commit('SET_ALLSOURCETYPELIST', res.result.allStrain)
          resolve(res.result.allStrain)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getSampleAgeUnit ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSamUnit(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getSampleRootClassification ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvRoot(data).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getTaxonSpecies ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSpecies(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    // sampleType
    getSampleFormValue ({commit}, list) {
      commit('SET_METAEXPMSLIST', list)
    },
    getSampleType ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSourceType(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getStrain ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvStrain(data).then((res) => {
          // console.log(res)
          // commit('SET_STRAIN', res.result.data)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getGenoType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvGenotype().then((res) => {
          // console.log(res)
          // commit('SET_GENOTYPE')
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSampleGender ({commit, state}) {
      return new Promise((resolve, reject) => {
        getCvGender().then((res) => {
          commit('SET_GENDER', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*type*/
    getSystemName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSystemName(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getOrganName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvOrganName(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getSystemAndOrgan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getCvOrganAndSystem(data).then((res) => {
          commit('SET_SYSORGAN', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getTissueName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvTissueName(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getTissueStatus ({commit}) {
      return new Promise((resolve, reject) => {
        getCvTissueStatus().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCellName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvCellName(data).then((res) => {
          commit('SET_CELLNAME', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCellType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvCellType().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMicroorganismType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvMicroorganismType().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMicroorganismName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvMicroorganismName(data).then((res) => {
          // commit('SET_MICROORGANISMNAME', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getOrganelle ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvOrganelle(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getFluid ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvFluid(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    /*storage*/
    getCvLocationType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvLocationType().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCvLocationTemperature ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvLocationTemperature(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*treatment*/
    getTreatmentMethod ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvTreatmentMethod(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTreatmentType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvTreatmentType().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTreatmentUnit ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvUnit(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTreatmentUnitType ({commit}) {
      return new Promise((resolve, reject) => {
        getCvUnitType().then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTreatAllUnit ({commit, state}) {
      return new Promise((resolve, reject) => {
        getCvUnitAll().then((res) => {
          commit('SET_TREATMENTALLUNIT', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // create samples
    createSamples ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSubmist(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // modify samples
    modifySamples ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifySample(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    delSamples ({commit}, data) {
      return new Promise((resolve, reject) => {
        deleteSample(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    /*table list*/
    getSampleTableList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleListData(data).then((res) => {
          resolve(res.result.list)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSampleListCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleListCount(data).then((res) => {
          resolve(res.result.total)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDraftSampleTableList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleListInProvidedIds(data).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getDraftSelectOtherTalbeList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleListNotInProvidedIds(data).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getSampleListNotInProvidedIdCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleListNotInProvidedIdCount(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getSamHighLightTableList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getSampleListAndStickAnEntry(data).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    // search & filter
    getSearchDescrip ({commit}, data) {
      return new Promise((resolve, reject) => {
        getDistinctDescription(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getFilterOperator ({commit}, data) {
      return new Promise((resolve, reject) => {
        getDistinctOperator(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getFilterSourceType ({commit}, data) {
      return new Promise((resolve, reject) => {
        getDistinctSourceType(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getSearchTreatmentA ({commit}, data) {
      return new Promise((resolve, reject) => {
        getDistinctTreatmentA(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getSearchTreatmentB ({commit}, data) {
      return new Promise((resolve, reject) => {
        getDistinctTreatmentB(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getCheckSample ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleView(data).then((res) => {
          commit('SET_CHECKSAMPLE', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getSampleTemplate ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSampleTemplate(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default samples



// WEBPACK FOOTER //
// ./src/store/modules/samples.js